import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { ActionMenuItem } from './ActionMenuItem';
import { CprActivityStatus } from 'src/graphql/generated';
import { AuthContext, AuthContextType } from 'src/contexts/AuthContext';

export const CprActions = ({ activity }: ActivityActionsProps) => {
  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');
  const { canImpersonate } = useContext(AuthContext) as AuthContextType;
  const statusReturned = activity?.status === CprActivityStatus?.CprReturned;
  const statusDraft = activity?.status === CprActivityStatus?.CprDraft;

  return (
    <>
      <NavLink to={'/cpr/' + activitykeyUrlEncoded}>
        {canImpersonate ? (
          statusDraft || statusReturned ? (
            <ActionMenuItem icon={'edit'} title={'Edit'} />
          ) : (
            <ActionMenuItem icon={'view'} title={'View'} />
          )
        ) : statusDraft || statusReturned ? (
          <ActionMenuItem icon={'edit'} title={'Edit'} />
        ) : (
          <ActionMenuItem icon={'view'} title={'View'} />
        )}
      </NavLink>
    </>
  );
};
